import { orchestrator } from 'satcheljs';
import { NOTIFICATION_DISMISS_TIMEOUT } from '../../constants/AppConstants';
import { onNotificationChanged, onNotificationRemoved } from '../actions';

orchestrator(onNotificationChanged, async (msg) => {
  if (!msg.notification.suppressAutoDismiss) {
    setTimeout(() => onNotificationRemoved(msg.notification), NOTIFICATION_DISMISS_TIMEOUT);
  }
});
